export const getCookieDomain = () => {
  const url = window.location.href;

  if (url.includes('linkareer')) return '.linkareer.com';
  if (url.includes('lnkr')) return '.lnkr.cc';
  return 'localhost';
};
